import modalTemplateUrl from '../../views/modals/create-template-modal.tpl.html';
import CreateWalletTemplateModalController from '../../controllers/modals/create-template-modal';

class createWallet {
    constructor($injector) {
        this.injector = $injector;
        this.state = this.injector.get('$state');
        this.translate = this.injector.get('$translate');
        this.modal = this.injector.get('$uibModal');

        this.key = 'create-passbook';
        this.level = 'highlight';
        this.icon = 'plus-circle';
        this.title = this.translate.instant('wallets.templates.workflows.list.create');
        this.order = 10;
    }

    action({}, store) {
        return this.modal
            .open({
                controller: CreateWalletTemplateModalController,
                controllerAs: 'vm',
                templateUrl: modalTemplateUrl,
                keyboard: false,
                backdrop: 'static',
            })
            .result
            .then(({wallet}) => {
                return this.state.go('app.wallets.templates.details', {
                    id: wallet.id
                });
            })
            .catch(() => {

            })
    }

}

angular
    .module('festzelt-os.modules.wallets.templates')
    .factory('createPassbook', [
        '$injector',
        ($injector) => new createWallet($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/workflows/list/create-wallet.js